/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

/**
 * Calculates the amount including taxes.
 * @param transaction
 * @returns {number}
 */
export function getAmountIncludingTax (transaction) {
  return [
    transaction.amount,
    transaction.vat,
    transaction.cps
  ].filter((v) => typeof v === 'number')
    .reduce((prev, curr) => prev + curr, 0)
}

/**
 * Sets expense from amount.
 * @param transaction
 * @returns {*}
 */
export function updateExpenseFromAmount (transaction) {
  const trans = { ...transaction }

  if (trans.amount > 0) {
    trans.expense = false
  } else if (trans.amount < 0) {
    trans.expense = true
  }
  return trans
}
